import Vue from 'vue'
import Router from 'vue-router'
import { loadLanguageAsync } from '@/lang/setup'
import VueGtm from '@gtm-support/vue2-gtm'

const defaultLanguage = process.env.DEFAULT_LANGUAGE


Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/terms/:page',
      name: 'terms',
      component: () => import(/* webpackChunkName: "terms" */ './views/unauthorized/Terms.vue'),
      meta: {
        noLayout: true,
        branches: ['new_york', 'stockholm', 'berlin'],
      },
    },
    {
      path: '/invite/:codes',
      name: 'invite',
      component: () => import(/* webpackChunkName: "invite" */ './views/unauthorized/InviteCodeRecorder.vue'),
    },
    {
      path: '/',
      name: 'membership',
      component: () => import(/* webpackChunkName: "membership" */ './views/app/Membership.vue'),
      meta: {
        requiresAuth: true,
        activeTab: 'membership'
      },
      children: [
        {
          path: 'checkout/:id',
          component: () => import(/* webpackChunkName: "stripe_payment_modal" */ './components/membership/StripePaymentModal.vue'),
          meta: {
            requiresAuth: true,
            // requiresAccessCode: true
          }
        },
        {
          path: 'success',
          component: () => import(/* webpackChunkName: "payment_success_modal" */ './components/membership/PaymentSuccessModal.vue'),
          meta: {
            requiresAuth: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'edit',
          component: () => import(/* webpackChunkName: "edit_modal" */ './components/membership/EditModal.vue'),
          meta: {
            requiresAuth: true,
            requiresMembership: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'switch',
          component: () => import(/* webpackChunkName: "switch_modal" */ './components/membership/SwitchModal.vue'),
          meta: {
            requiresAuth: true,
            requiresMembership: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'cancel',
          component: () => import(/* webpackChunkName: "cancel_modal" */ './components/membership/CancelModal.vue'),
          meta: {
            requiresAuth: true,
            requiresMembership: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'upgrade',
          name: 'upgrade',
          component: () => import(/* webpackChunkName: "upgrade_wall_modal" */ './components/membership/upgrade/WallModal.vue'),
          meta: {
            requiresAuth: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'upgrade/success',
          name: 'upgradeSuccess',
          component: () => import(/* webpackChunkName: "upgrade_success_modal" */ './components/membership/upgrade/SuccessModal.vue'),
          meta: {
            requiresAuth: true,
            activeTab: 'membership'
          }
        },
        {
          path: 'member-tickets',
          component: () => import(/* webpackChunkName: "edit_modal" */ './components/membership/MemberTickets.vue'),
          meta: {
            requiresAuth: true,
            requiresMembership: true,
            activeTab: 'membership'
          }
        },

      ]
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import(/* webpackChunkName: "payment" */ './views/app/Payment.vue'),
      meta: {
        requiresAuth: true,
        requiresMembership: true,
        activeTab: 'payment'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/app/Profile.vue'),
      meta: {
        requiresAuth: true,
        activeTab: 'profile'
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "signup" */ './views/unauthorized/NotLoggedIn.vue'),
      children: [
        {
          path: 'checkout/:checkoutId',
          component: () => import(/* webpackChunkName: "register" */ './views/unauthorized/Register.vue'),
          meta: {
            requiresUnauth: true,
            // requiresAccessCode: true
          }
        },
        // {
        //   path: '',
        //   component: () => import(/* webpackChunkName: "becomeMember" */ './views/unauthorized/BecomeAMember.vue')
        // },
        {
          path: '',
          component: () => import(/* webpackChunkName: "register" */ './views/unauthorized/Register.vue'),
          meta: {
            requiresUnauth: true,
            // requiresAccessCode: true
          }
        },
        {
          path: 'login',
          component: () => import(/* webpackChunkName: "login" */ './views/unauthorized/Login.vue'),
          meta: {
            requiresUnauth: true,
            // requiresAccessCode: true
          }
        },
        {
          path: 'update-password',
          component: () => import(/* webpackChunkName: "update_password" */ './views/unauthorized/UpdatePassword.vue'),
          meta: {
            // requiresAccessCode: true
          },
          children: [
            {
              path: 'invite/:codes',
              component: () => import(/* webpackChunkName: "update_password_codes" */ './views/unauthorized/UpdatePassword.vue'),
              meta: {
                // requiresAccessCode: true
              },
            }
          ],
        },
        {
          path: 'reset-password',
          component: () => import(/* webpackChunkName: "reset_password" */ './views/unauthorized/ResetPassword.vue'),
          meta: {
            // requiresAccessCode: true
          }
        }
      ]
    },

    /*{
      path: '/become-a-member',
      name: 'becomeAMember',
      component: () => import(/!* webpackChunkName: "become_a_member" *!/ './views/unauthorized/BecomeAMember.vue'),
      children: [
        {
          path: 'early-access',
          component: () => import(/!* webpackChunkName: "sign_up_for_early_access" *!/ './views/unauthorized/SignupForEarlyAccess.vue'),
        }
      ]
    }*/

    {
      path: '/:catchAll(.*)',
      component: () => import(/* webpackChunkName: "not_found" */ './views/unauthorized/NotFound.vue'),
      name: 'NotFound',
      meta: {
        noLayout: true,
      },
    },

  ]
})

if (process.env.GTM) {
  Vue.use(VueGtm, {
    id: process.env.GTM,
    vueRouter: router
  });
}

router.beforeEach((to, from, next) => {
  let lang = to.params.lang || defaultLanguage
  loadLanguageAsync(lang)
    .then(() => next())
})

export default router
